import { inferenceHttp } from '@/lib/api/inference-client';
import {
  EtlService,
  EtlContentSourceDto,
  CreateEtlContentSourceDto,
  UpdateEtlContentSourceDto,
} from '@inference.engine/api-client/web';
import { logger } from '@/lib/utils/logger';

export const getContentSources = async (): Promise<EtlContentSourceDto[]> => {
  try {
    const response = await EtlService.getContentSources({ client: inferenceHttp });
    return response.data ?? [];
  } catch (error) {
    logger.error('Failed to fetch content sources:', error);
    throw error;
  }
};

export const addContentSource = async (
  contentSource: CreateEtlContentSourceDto,
): Promise<EtlContentSourceDto> => {
  try {
    const response = await EtlService.addContentSource({
      client: inferenceHttp,
      body: contentSource,
    });
    if (!response.data || typeof response.data !== 'object' || !('id' in response.data)) {
      throw new Error('Failed to add content source: Invalid response');
    }
    return response.data as EtlContentSourceDto;
  } catch (error) {
    logger.error('Failed to add content source:', error);
    throw error;
  }
};

export const updateContentSource = async (
  contentSource: UpdateEtlContentSourceDto,
): Promise<void> => {
  try {
    const response = await EtlService.updateContentSource({
      client: inferenceHttp,
      body: contentSource,
    });
    // Check for errors in the response
    if (response.error || (response.status && response.status >= 400)) {
      throw new Error('Failed to update content source');
    }
  } catch (error) {
    logger.error('Failed to update content source:', error);
    throw error;
  }
};

export const deleteContentSource = async (id: string): Promise<void> => {
  try {
    await EtlService.deleteContentSource({
      client: inferenceHttp,
      query: { id },
    });
  } catch (error) {
    logger.error('Failed to delete content source:', error);
    throw error;
  }
};
